// Кироса — active: «1 раз за бой захвати контроль над вражеским юнитом с атакой 3 или меньше».
// А.4.5-fix3. Двух-ступенчатая активация в Ф4 владельца:
//   шаг 1 — выбор вражеского юнита (legal target),
//   шаг 2 — выбор своего свободного слота.
//
// Захват:
//   - убрать с поля бывшего владельца (без вызова обработчиков смерти);
//   - поставить на сторону Кироса в выбранный слот; ownerId = playerIdx;
//   - юнит считается выставленным в текущем ходу (placedTurn = state.currentTurn);
//   - Режим ожидания не действует — юнит, призванный не из руки, активен сразу
//     (диздок 6.6 «Исключение: карты, призванные не из руки»). Реализуем как
//     initiation = 0 у захваченной карты.
//   - HP, броня (current), keywords, persistent-баффы — переносятся как есть.
//   - Аура Второго директора пересчитывается у обоих игроков.

import { recomputeDirectorAura } from './vtoroy-direktor.js';
import { recomputeUnitWithMods } from '../syntetics/modifications.js';
import { hasKeyword, KW } from '../../keywords.js';

export const HERO_ID = 'deus_kirosa';
const MAX_TARGET_ATK = 3;

// Юнит, который Кироса может захватить.
function isLegalTarget(card) {
  if (!card) return false;
  if (card.type !== 'unit') return false;
  if (!card.isAlive()) return false;
  if (card.atk > MAX_TARGET_ATK) return false;
  if (card.sleeperState != null) return false;        // Спящий агент не захватывается
  if (hasKeyword(card, KW.STEALTH)) return false;     // Скрытный не захватывается
  return true;
}

// Список всех легальных целей у противника.
export function getKirosaTargets(state, playerIdx) {
  const enemy = state.players[1 - playerIdx];
  return enemy.unitsOnField().filter(isLegalTarget);
}

// Доступна ли способность.
export function kirosaActiveAvailable(state, playerIdx) {
  const p = state.players[playerIdx];
  if (!p || p.hero.id !== HERO_ID) return false;
  if (p.heroActiveUsed) return false;
  if (!p.hasFreeSlot()) return false;
  if (getKirosaTargets(state, playerIdx).length === 0) return false;
  return true;
}

// Захват. targetCard — Card на стороне противника. slot — {line, slot} на стороне Кироса.
// Возвращает {ok: true} или {ok: false, reason}.
export function kirosaActive(state, playerIdx, targetCard, slot) {
  const p = state.players[playerIdx];
  if (!p || p.hero.id !== HERO_ID) return { ok: false, reason: 'unavailable' };
  if (p.heroActiveUsed) return { ok: false, reason: 'unavailable' };
  if (!targetCard || !isLegalTarget(targetCard)) {
    return { ok: false, reason: 'invalid_target' };
  }
  const enemy = state.players[1 - playerIdx];
  if (!enemy.unitsOnField().includes(targetCard)) {
    return { ok: false, reason: 'invalid_target' };
  }
  if (!slot || typeof slot.line !== 'number' || typeof slot.slot !== 'number') {
    return { ok: false, reason: 'invalid_slot' };
  }
  if (slot.line < 0 || slot.line > 1 || slot.slot < 0 || slot.slot > 3) {
    return { ok: false, reason: 'invalid_slot' };
  }
  if (p.field[slot.line][slot.slot] !== null) {
    return { ok: false, reason: 'slot_occupied' };
  }
  // Снять с поля бывшего владельца БЕЗ обработчиков смерти.
  const oldLine = targetCard.line, oldSlot = targetCard.slot;
  if (oldLine !== null && oldSlot !== null && enemy.field[oldLine]?.[oldSlot] === targetCard) {
    enemy.field[oldLine][oldSlot] = null;
  }
  targetCard.line = null;
  targetCard.slot = null;
  // Захват не из руки — Режим ожидания снимается.
  targetCard.initiation = 0;
  targetCard.placedTurn = state.currentTurn;
  // Поставить на сторону Кироса.
  p.placeCard(targetCard, slot.line, slot.slot);
  targetCard.ownerId = p.id;          // placeCard перетёр — восстанавливаем (а здесь и есть p.id, но для ясности)
  // Лог.
  state.log.add(`🎯 Кироса [${p.name}] [active] → захватил «${targetCard.name_ru}» [${enemy.name}] на ${slot.line === 0 ? '1-ю' : '2-ю'} линию (слот ${slot.slot + 1})`);
  // Кулдаун.
  p.heroActiveUsed = true;
  // Пересчёт ауры Второго директора у обоих сторон (захваченный больше не союзник врага).
  recomputeDirectorAura(state);
  // Б.1.b: Модификации физически переехали с объектом Card — дельты сохранены.
  // recomputeUnitWithMods — no-op в Б.1.b, оставлен явной точкой для будущих расширений.
  recomputeUnitWithMods(targetCard);
  // TODO Глобал: при захвате может потребоваться пересчёт Цепи командования.
  return { ok: true };
}
